module.exports = __webpack_public_path__ + "static/media/drop-down-arrow.e2327a17.svg";